// extracted by mini-css-extract-plugin
export default {"paymentsDashboardCardsContainer":"session-history_paymentsDashboardCardsContainer__w6Jls","sessionHistoryPageContainer":"session-history_sessionHistoryPageContainer__xMeg4"};